import React, { useState } from 'react';
import ChapterDetailCard from '../ChapterDetailCard';
import ReplaceableContent from '../ReplaceableContent';
import Button from '../Button';
import { researchProjects } from '../../data/projects';

const ChapterDetails = ({ chapter, discordUrl, instagramUrl }) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const chapterProjects = researchProjects.filter(project =>
    project.chapter === chapter.name &&
    project.status?.toLowerCase() !== 'completed'
  );

  const chapterWithProjectCount = {
    ...chapter,
    stats: {
      ...chapter.stats,
      activeProjects: chapterProjects.length,
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(`Email submitted for ${chapter.name}:`, email);
    setSubmitted(true);
    setEmail('');
  };

  return (
    <div style={{
      maxWidth: '1100px',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    }}>
      <ChapterDetailCard {...chapterWithProjectCount} />

      <section 
      id="get-involved"
      style={{
        scrollMarginTop: '140px',
        maxWidth: '900px',
        width: '100%',
        textAlign: 'center',
        marginTop: '3rem'
      }}>
        <h1 className="title">Get Involved at {chapter.name}</h1>
        <p className="subtitle" style={{ marginBottom: '2rem' }}>
          Whether you're just getting started or already experimenting with quantum ideas, {chapter.name} is your launchpad.
        </p>

        <div style={{
          background: '#0F0F1A',
          border: '1px solid rgba(99, 102, 241, 0.25)',
          borderRadius: '.75rem',
          padding: '2rem',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          display: 'flex',
          flexDirection: 'column',
          gap: '2.5rem',
          marginBottom: '3rem',
        }}>
          {[
            {
              title: '#1: Research Track',
              id: 'research-track',
              image: '/groups/umd-laugh.jpg',
              description: `Go from beginner to published researcher in 3 semesters, no prior experience needed.
              Collaborate on real projects with guidance from UMD’s quantum experts.`
            },
            {
              title: '#2: Weekly Workshops',
              id: 'workshops',
              image: '/groups/workshop.jpg',
              description: `Learn quantum concepts hands-on. Perfect for curious students from any major.
              Every workshop is beginner-friendly and project-focused.`
            },
            {
              title: '#3: Chapter Lab',
              id: 'lab',
              image: '/lab.jpg',
              description: `Research in sandbox-like teams applying quantum to fields like finance, medicine, and more.
              Collaborate with on-campus departments and industry.`
            },
            {
              title: 'Course Credit, Internships, and Conferences',
              id: 'conferences',
              image: '/groups/conference.jpg',
              description: `Earn class credit for a practicum course, secure internships, gain exclusive invitations to premium conferences 
              with leaders from academia, industry, and government - just like other Researchers already have.`
            }
          ].map((item, i) => (
            <div key={i} id={item.id} style={{ scrollMarginTop: '140px' }}>
              <h2 className="title" style={{ marginBottom: '0.75rem' }}>{item.title}</h2>
              <img
                src={item.image}
                alt={item.title}
                style={{
                  width: '100%',
                  maxHeight: '180px',
                  objectFit: 'cover',
                  borderRadius: '0.5rem',
                  border: '1px solid rgba(255,255,255,0.1)',
                  marginBottom: '1rem',
                }}
              />
              <p className="big-content-text">{item.description}</p>
            </div>
          ))}
        </div>

        <div
        id='discord' 
        style={{
          scrollMarginTop: '140px',
          backgroundColor: '#0F0F1A',
          border: '1px solid rgba(99, 102, 241, 0.25)',
          borderRadius: '.75rem',
          padding: '2rem',
          maxWidth: '600px',
          margin: '0 auto',
        }}>
          <h2 className="title" style={{ marginBottom: '1.5rem' }}>
            For Deadlines, Workshops, and More
          </h2>

          {discordUrl && (
            <Button
              label={
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem' }}>
                  <img src="/discord.png" alt="Discord" style={{ width: '24px', height: '24px' }} />
                  Join Us on Discord
                </span>
              }
              to={discordUrl}
              style={{ maxWidth: '320px' }}
              base="#5865F2"
              hover="#4752C4"
              pressed="#3a45a1"
            />
          )}
        </div>
      </section>
    </div>
  );
};

export default ChapterDetails;
